module.exports = __webpack_public_path__ + "static/media/meme_16.1029da2d.png";